import styled from "styled-components"
import { breakpoint } from "../../../configs/utilities"

export const LayoutWrapper = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 0 20px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 0 100px;
  }
`

export const ContentWrapper = styled.div`
  max-width: 1200px;
  padding: 0 20px;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 0 30px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 0 60px;
  }
`

export const SectionWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${props => (props.paddingSm ? props.paddingSm : "30px 20px")};

  @media screen and (min-width: ${breakpoint.md}) {
    padding: ${props => (props.paddingMd ? props.paddingMd : "50px 50px")};
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: ${props => (props.paddingXl ? props.paddingXl : "70px 100px")};
  }
`

export const SectionWrapperNoSpace = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 5px 50px;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 10px 100px;
  }
`

export const GlobalPadding = styled.div`
  max-width: 1380px;
  padding: 0 20px;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 0 30px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 0 60px;
  }
`

export const FlexLeftRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 30px;
  padding: 15px 0;

  @media screen and (min-width: ${breakpoint.md}) {
    flex-direction: row;
    column-gap: 30px;
    padding: 30px 0;
  }

  @media screen and (min-width: ${breakpoint.xxl}) {
    column-gap: 80px;
  }
`

export const FlexLeftRightWrapperItem = styled.div`
  width: 100%;
  padding: 0 20px;

  @media screen and (min-width: ${breakpoint.md}) {
    width: 50%;
  }
`
